import React from 'react'
import FormSelect from 'components/forms/bases/FormSelect'

const HtmlTagsSelector = ({
  ...props,
}) => {
  return (
    <FormSelect
      label="Tags"
      {...props}
      options={
        [
          'h1',
          'h2',
          'h3',
          'h4',
          'h5',
          'p',
          'span',
          'a',
        ]
      }
    />
  )
}

HtmlTagsSelector.propTypes = {}
HtmlTagsSelector.defaultProps = {}

export default HtmlTagsSelector



// WEBPACK FOOTER //
// ./src/components/forms/TextTagsSelector.js